import React, { useEffect, useState } from "react";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import { ManageCategory, showMessage } from "../../Functionalities/Functions";
import AddTopComponent from '../../CoreComponents/AddTopComponent'
import AddBottomComponent from '../../CoreComponents/AddBottomComponent'
import ImageUploadWithCrop from "../../CoreComponents/ImageUploadWithCrop";

function Body() {
  const [disable, setdisable] = useState(false)
  const [data, setData] = useState({
    id: "",
    name: "",
    bg_image: "",
    icon: "",
    is_active: 1,
    is_blocked: false,
    inner_category: false
  });

  const [key, setKey] = useState(new Date());

  const [errors, setErrors] = useState([]);

  useEffect(() => {
    if (errors.length > 0) {
      showMessage(
        errors[0],
        "danger",
        "Following fields required!",
        "top",
        "top-right",
        0
      );
    }
  }, [errors]);
  return (
    <div class="content-body">
      <div class="container-fluid">

        <AddTopComponent path={"categories"}/>
        <div className="col-xl-12 col-lg-12">
          <div className="card">
            <div className="card-body">
              <div className="basic-form">
                <form
                // onSubmit={callAddCategory(data)}
                >
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label">
                      Category name
                      <span className="required">*</span>
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        value={data.name}
                        onChange={(e) =>
                          setData({ ...data, name: e.target.value })
                        }
                      />
                    </div>
                  </div>

                  <div className="form-group row">

                    <label className="col-sm-3 col-form-label">Icon<span className="required">*</span></label>
                    <div className="col-sm-9">
                      <ImageUploadWithCrop
                        value={data.icon}
                        onChange={(file) =>
                          setData({ ...data, icon: file })
                        }
                        aspectRatio={1}
                        compress={false}
                      />
                    </div>
                  </div>

                  {/* <div className="form-group row">
                    <label className="col-sm-3 col-form-label">Is Menu</label> */}

                  {/* <div className="col-sm-2 ">
                      <div className="custom-control custom-checkbox mb-3">
                        <input
                          type="checkbox"
                          checked={data.inner_category}
                          value={data.inner_category}
                          // disabled={!Edit}
                          onClick={(e) =>
                            setData({ ...data, inner_category: e.target.checked })
                          }
                          className="custom-control-input"
                          id="customCheckBox1"
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="customCheckBox1"
                        >
                          Active
                          </label>
                      </div>
                    </div> */}
                  {/* </div> */}






                  <AddBottomComponent
                    disable={disable}
                    saveButton={(e) => {
                      e.preventDefault();
                      setdisable(true)
                      setErrors([]);
                      if (data.name === "") {
                        setdisable(false)
                        setErrors(["Category name"]);
                        return;
                      }
                      // if (data.bg_image === "") {
                      //   setErrors(["Background image"]);
                      //   return;
                      // }
                      if (data.icon === "") {
                        setdisable(false)
                        setErrors(["Icon"]);
                        return;
                      }
                      let res = ManageCategory(e, data, "add");
                      res.then((res) => {
                        setdisable(false)
                        // void 0
                        if (res.data.Status === true) {
                          showMessage("Category added", "success", "Success!", "top", "top-right", 0);
                          setData({
                            id: "",
                            name: "",
                            bg_image: "",
                            icon: "",
                            is_active: 1,
                            is_blocked: "false",
                          });
                          setKey(Date.now());
                        } else {
                          showMessage(res.data.Error, "danger", "Failed!", "top", "top-right", 0);
                        }
                      });
                    }} />


                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function AddCategory() {
  const headers = "Add Category";
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name={headers} />
        <NavBar />
        {/* <Body bo={boln} na={name} nu={num} ar={ary} ob={obj} ao={aryobj} /> */}
        <Body />
        <Footer />
      </div>
    </div>
  );
}

export default AddCategory;
